import React from "react";
import { Box } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import JobHistoryDialog from "./components/JobHistoryDialog";

/**
 * The policy's History as a full page (2026-10-22: "a lot of data - the dialog does not show it clearly"):
 * /onlinePolicy/view/history/:policyId. The same content as the old dialog (components/JobHistoryDialog.js, page
 * variant): summary, Runs, money, timeline, manual changes, edits, errors.
 */
const ViewOnlinePolicyHistory = () => {
  const { policyId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const customerName = (location.state && location.state.name) || "";
  return (
    // its own page (Dashboard routes /onlinePolicy/view/history/:id here) - no Online Policy card around it
    // phones: the app frame's 26px sides are cut to 8px so the page gets the screen's width
    <Box sx={{ width: { xs: "calc(100% + 36px)", sm: "100%" }, mx: { xs: "-18px", sm: 0 }, px: { xs: 0, sm: 1.5, md: 3 }, pb: 2, boxSizing: "border-box" }}>
      <JobHistoryDialog
        variant="page"
        open
        policyId={policyId}
        customerName={customerName}
        onClose={() => navigate("/onlinePolicy")}
        // the shortcut bar's buttons: the policy's other pages, one click away
        actions={[
          { label: "Policy details", icon: <DescriptionOutlinedIcon />, onClick: () => navigate(`/onlinePolicy/view/form/${policyId}`) },
          { label: "Issues page", icon: <ReportProblemOutlinedIcon />, onClick: () => navigate(`/onlinePolicy/view/error_logs/${policyId}`) },
        ]}
      />
    </Box>
  );
};

export default ViewOnlinePolicyHistory;
